import React from 'react'
import { omit } from 'utils'
import PropTypes from 'prop-types'

// const overlayStyles = {
//   position: 'absolute',
//   filter: 'blur(1px)',
//   opacity: 1,
//   transition: 'opacity ease-in 1000ms',
//   clipPath: 'inset(0)',
// }

// const medOverlayStyle = {
//   // position: 'absolute',
//   // top: '0px',
//   // left: '0px',
//   // width: '100%',
//   // height: '100%',
//   // objectFit: 'cover',
//   // objectPosition: 'center center',
//   opacity: '1',
//   transition: 'opacity 500ms ease 0s',
// }

const LazyLoadImage = React.memo(props => {
  const [highResImageLoaded, setHighResLoaded] = React.useState(false)
  const { alt, className, overlaySrc, src } = props
  const filteredProps = omit(props, 'overlaySrc')

  return (
    // <span style={{ position: 'relative', width: '100%', height: '100%' }}>
    <span>
      <img
        {...filteredProps}
        alt={alt}
        onLoad={() => console.log('thumb load')}
        className={`${className} lazy-image-overlay`}
        {...(highResImageLoaded && { style: { opacity: '0' } })}
        src={overlaySrc}
      />
      {/* <div
          style={{
            width: '100%',
            height: '100%',
            backgroundImage: `url(${overlaySrc})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
          //   alt={alt}
          //   onLoad={() => console.log('thumb load')}
          className={`${className} lazy-image-overlay`}
          {...(highResImageLoaded && { style: { opacity: '0' } })}
          src={overlaySrc}
        /> */}
      <img
        {...filteredProps}
        alt={alt}
        onLoad={() => {
          console.log('image loaded')
          setHighResLoaded(true)
        }}
        src={src}
      />
    </span>
  )
})

LazyLoadImage.propTypes = {
  overlaySrc: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  className: PropTypes.string,
  alt: PropTypes.string,
}

LazyLoadImage.defaultProps = {
  className: '',
  alt: '',
}

export default LazyLoadImage
